import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Footer from 'components/footer';
import { Header } from './components';
import Spinner from 'components/spinner';
import { useComponentVisibility } from 'hooks/useComponentVisibility';

const AppLayout = () => {
  const checkingAuth = useSelector(state => state.user.checkingAuth);
  const loadingLocales = useSelector(state => state.forms.loadingLocales);
  const loadingUser = useSelector(state => state.user.loadingUser);
  const { isLoading: loadingIsUserValidated } =
    useSelector(state => state.user.checkValidated);
  const showHeader = useComponentVisibility('header');
  const showFooter = useComponentVisibility('footer');
  const [showHeaderComponent, setShowHeaderComponent] = useState(false);
  const [showFooterComponent, setShowFooterComponent] = useState(false);

  useEffect(()=> {
    setShowHeaderComponent(showHeader);
    setShowFooterComponent(showFooter);
  },[showHeader, showFooter])

  const loading =
    loadingLocales || checkingAuth || loadingUser || loadingIsUserValidated;

  return (
   <div className="app-container">
      {showHeaderComponent && <Header />}
      <>
        <Spinner />
        <Outlet />
      </>
      {(showFooterComponent && !loading) && <Footer />}
    </div>
  );
};

export default AppLayout;
